import cx from 'classnames';
import CTContentTitle from './CTContentTitle';
import styles from '../ConditionalTile.module.scss';
import CTButton from '../CTButton';

type OwnProps = {
  backgroundButton?: boolean;
  button?: boolean;
  buttonText?: string;
  hasMobileSubText?: boolean;
  isMobile?: boolean;
  light?: boolean;
  options: {
    heading1?: string;
    heading2?: string;
    subHeading?: string;
  };
  primaryButton?: boolean;
  top?: boolean;
  useMobileStyle?: boolean;
};

export default function CTContent({
  light = false,
  top = false,
  options: { heading1, heading2, subHeading },
  isMobile = false,
  button = false,
  backgroundButton,
  primaryButton,
  buttonText,
  hasMobileSubText = false,
  useMobileStyle = true
}: OwnProps) {
  return (
    <div
      className={cx(
        styles.ctContent,
        'flex flex-col items-center pt-12 w-[272px]',
        {
          top,
          mobile: isMobile && useMobileStyle
        }
      )}
    >
      <CTContentTitle
        isMobile={isMobile && useMobileStyle}
        light={light}
        heading1={heading1}
        heading2={heading2}
      />
      <p
        className={cx(
          styles.ctContentText,
          'block mt-4 pb-20 text-center tl-body-m w-[272px]',
          {
            light,
            mobile: isMobile,
            hasMobileSubText
          }
        )}
      >
        {subHeading}
      </p>
      {button && (
        <CTButton
          backgroundButton={backgroundButton}
          isMobile={isMobile}
          light={light}
          primaryButton={primaryButton}
          text={buttonText}
          visible={button}
        />
      )}
    </div>
  );
}
